import React from 'react';
import { ArrowRight } from 'lucide-react';

const VALUE_PROPS = [
  { title: 'PREMIUM QUALITY', text: 'Finest fabrics and expert craftsmanship' },
  { title: 'EVERY OCCASION', text: 'Weddings, formal events, business & beyond' },
  { title: 'EASY SHOPPING', text: 'Secure checkout and fast delivery' },
];

const Hero = ({ onNavigate }) => {
  return (
    <section className="relative min-h-screen flex flex-col overflow-hidden bg-[#001B2A]">
      {/* Split Screen */}
      <div className="flex-1 grid md:grid-cols-2 min-h-screen">
        {/* Left: Content */}
        <div className="flex items-center bg-[#001B2A] px-6 sm:px-10 lg:px-16 pt-28 pb-12 md:py-0">
          <div className="max-w-xl space-y-6">
            <p className="text-[#E6D7B3] tracking-[0.3em] text-xs sm:text-sm font-semibold">
              MENS FASHION
            </p>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-serif text-white leading-tight">
              Timeless Style.
              <br />
              <span className="text-[#E6D7B3]">Perfected.</span>
            </h1>

            <p className="text-base sm:text-lg text-gray-300 max-w-md">
              Premium bow ties and menswear for every occasion.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <button
                onClick={() => onNavigate('bow-ties')}
                className="group inline-flex items-center justify-center px-6 sm:px-8 py-3 sm:py-4 bg-[#7B1E2B] text-white font-medium text-sm sm:text-base rounded-sm hover:bg-[#E6D7B3] hover:text-[#001B2A] transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
              >
                SHOP BOW TIES
                <ArrowRight className="ml-2 h-4 w-4 sm:h-5 sm:w-5 group-hover:translate-x-1 transition-transform" />
              </button>

              <button
                onClick={() => onNavigate('neckties')}
                className="group inline-flex items-center justify-center px-6 sm:px-8 py-3 sm:py-4 bg-transparent border-2 border-white/60 text-white font-medium text-sm sm:text-base rounded-sm hover:bg-white hover:text-[#001B2A] transition-all duration-300 transform hover:-translate-y-0.5"
              >
                EXPLORE COLLECTION
                <ArrowRight className="ml-2 h-4 w-4 sm:h-5 sm:w-5 group-hover:translate-x-1 transition-transform" />
              </button>
            </div>

            {/* Value Props */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 pt-8">
              {VALUE_PROPS.map((prop) => (
                <div key={prop.title} className="bg-white/5 border border-white/10 rounded-lg p-4">
                  <h3 className="text-[#E6D7B3] font-semibold text-xs sm:text-sm mb-1">{prop.title}</h3>
                  <p className="text-gray-300 text-xs">{prop.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Right: Image */}
        <div className="relative min-h-[50vh] md:min-h-full">
          <img
            src="https://images.pexels.com/photos/7037037/pexels-photo-7037037.jpeg"
            alt="Gentleman wearing a bow tie"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#001B2A]/60 via-transparent to-transparent"></div>
          <div className="absolute bottom-6 right-6 bg-[#7B1E2B]/90 backdrop-blur-sm text-white px-5 py-3 rounded-md shadow-lg">
            <p className="font-serif text-lg">The Bow Tie Guy</p>
            <p className="text-xs text-[#E6D7B3] tracking-widest">SINCE 1977</p>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce hidden md:block">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-2 bg-white/50 rounded-full"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
